export default __webpack_public_path__ + "static/media/Background.8503c939.jpeg";